import { render } from "./MerchantClientList.vue?vue&type=template&id=58dae2ce&scoped=true"
import script from "./MerchantClientList.vue?vue&type=script&lang=js"
export * from "./MerchantClientList.vue?vue&type=script&lang=js"

import "./MerchantClientList.vue?vue&type=style&index=0&id=58dae2ce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dae2ce"]])

export default __exports__